import ECharts from 'echarts-for-react';
import { useMemo } from 'react';
import useConfig from 'hooks/useConfig';

const chartDataInit = {
  series: [
    {
      type: 'gauge',
      startAngle: 225,
      endAngle: -45,

      animationDuration: 1000,
      animationEasing: 'cubicOut',

      pointer: { show: false },

      progress: {
        show: true,
        roundCap: true,
        itemStyle: {
          color: '#2672f7',
          borderColor: '#000',
          borderWidth: 1,
        },
      },

      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 10,
          color: [[1, '#b2b2b2']],
        },
      },

      splitLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },

      data: [{ value: 0 }],

      detail: {
        show: true,
        valueAnimation: true,
        formatter: '{value}%',
        fontSize: 18,
        fontWeight: 'bold',
        offsetCenter: [0, '5%'],
        color: '#2672f7',
      },

      title: {
        show: false,
        fontSize: 12,
        offsetCenter: [0, '10%'],
      },
    },
  ],
};

export function CircleChart({
  optionData,
  angleType = 'ring',
  viewType = '',
  width = '150px',
  height = '150px',
}) {
  const { mode } = useConfig();

  const chartOption = useMemo(() => {
    if (!optionData || optionData.length === 0) return null;

    const titleColor = mode === 'light' ? '#000000' : '#ffffff';

    let series = {
      ...chartDataInit.series[0],
    };

    // 🔹 각도 설정
    if (angleType === 'ring') {
      series.startAngle = 90;
      series.endAngle = -270;
    } else {
      series.startAngle = 225;
      series.endAngle = -45;
    }

    // 🔹 데이터 개수별 처리
    if (optionData.length === 1) {
      series.data = optionData;
      series.detail = {
        ...series.detail,
        formatter: viewType === 'temp' ? '{value}%' : '{value}',
      };
    }

    if (optionData.length === 2 || optionData.length === 3) {
      series.data = optionData.map((d, idx) => ({
        ...d,
        title: { offsetCenter: ['0%', `${-30 + idx * 40}%`] },
        detail: { offsetCenter: ['0%', `${-10 + idx * 40}%`] },
      }));
    }

    series.title = { ...series.title, color: titleColor };

    return {
      ...chartDataInit,
      series: [series],
    };
  }, [optionData, angleType, viewType, mode]);

  if (!chartOption) return null;

  return (
    <div style={{ width, textAlign: 'center' }}>
      <ECharts
        option={chartOption}
        opts={{ renderer: 'svg', width, height }}
        style={{ height }}
      />
    </div>
  );
}

export default CircleChart;
